import React, { useState, useContext } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { FaHome } from 'react-icons/fa';

import './NavbarLog.css';

const NavbarLog = ({ toggleSidebar, toggleFilter, iconeFiltro, isFilterActive }) => {
  const [isUserMenuOpen, setIsUserMenuOpen] = useState(false);
  const location = useLocation();
  const excludedRoutes = ['/home', '/usuarios', '/dashboard'];

  const iconsize = 26;


  return (
    <nav className="navbar">
      <div className="navbar-content">


        <div className="logo-center">
          <a href="https://www.saibrasil.com.br/" target="_blank" rel="noopener noreferrer">
            <img src={`${process.env.PUBLIC_URL}/cohab_logo.png`} alt="Logo" className="white-logo" />
            <img src={`${process.env.PUBLIC_URL}/geocohab.png`} alt="Logo" className="white-geocohab-logo" />
          </a>
        </div>

        <div className="nav-right">
          <div className="nav-icons">
            <Link to="/home"><FaHome size={iconsize} /></Link>
          </div>
        </div>
      </div>
    </nav>
  );
};

export default NavbarLog;